import apiUrl from '../../../../constants'
import axios from 'axios'
import CryptoJS from 'crypto-js';
import { Validator } from 'vee-validate'
import VueElementLoading from 'vue-element-loading';
import Paginate from "vuejs-paginate";
import PageTracker from '../../../../common/PageTrackerHelper'

export default {
  name: 'Bulk Transit Lost Mark',
  components: {
    VueElementLoading,
    Paginate,
  },
  mixins:[PageTracker],
  data: function() {
    return {
      isShowing: false,
      pageno: 1,
      pagecount: 0,
      shipmentlogmodal: false,
      isLoading: false,
      isSearchLoading: false,
      isSaveLoading: false,
      shipmentList:[],
      lostBagShipments:[],
      form:{
          shippingidchk:[],
          values:[],
          checkboxval:[]
      },
      bagno : '',
      debitFromObj : [{"Id":"Coloader","Name":"Coloader"},{"Id":"NetworkVendor","Name":"NetworkVendor"}],
      debitToObj : [],
      DocketNumber : '',
      comments : '',
      max : '',
      debitFrom : '',
      debitTo : '',
      selectedItems: [],
      OctroiMRP : [],
      netPayment : [],
      TotalDebitAmount : 0.00,
      TotalNetAmt : 0.00,
      TotaloctroAmt : 0.00,
      shipmentList : '',
      localusermailid : '',
      localuserid : '',
      totalRecord:0,
      selectedCount:0,
      lostDebitCheckAll: false,
      shippingIdForMeta : [],
      userDataKey : '',
    }
  },
  created: function() {
  },
  async mounted() {
    this.userDataKey = window.localStorage.getItem('userUniqueKey');
    let validateUser = await this.validateJwtToken();
    //this.getHubServiceCenterData();
    var userdetailEncrypt = window.localStorage.getItem('lmaccessuserdata')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), this.userDataKey);
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.localuserid = userdetail.userid;
    this.localusermailid = userdetail.email;
    // console.log('this.localusermailid',this.localusermailid);

    //console.log('Mixin is working for :',result);
  },
  methods: {
    validateForm(scope) {
      this.$validator.validateAll(scope).then(result => {

        if (result) {
          //scope.chkSelect = this.chkSelect.join(',');
          //scope.availability = this.availability.join(',');
          let temparr = [];
          let shipmentArr = [];
          if(this.form.shippingidchk.length==0){
            this.$alertify.error("Please select shipment(s)!");
          } else {
            //console.log(this.form.shippingidchk);
            let payload = [];
          this.form.shippingidchk.forEach((item)=>{
            let tempArr = item.split('_');
            this.shippingIdForMeta = tempArr[0];
            let approvedBy = this.localusermailid;
            let shipmentObj = {
                       "ShippingID":tempArr[0],
                       "DebitMode":this.ddldebitmode,
                       "DepositDate":(this.depositDate!=undefined)?this.depositDate:'',
                       "FileUpload":'temp',
                       "ApprovalBy":approvedBy
                     };
                     payload.push(shipmentObj);
          });

          //console.log('payload',payload);
          axios.post(apiUrl.api_url + 'transitApproval/confirm', payload)
            .then((response) => {
              let TrackerInfo = {
                projectname:"Last Mile",
                type:"Web",
                userid:this.localuserid,
                username:this.localusermailid,
                meta: {
                    "event":"searchTransitApprovalData",
                    "DebitMode":this.ddldebitmode,
                    "shippingId" : this.shippingIdForMeta.toString()
                }

                }
                this.PageTracker(TrackerInfo);
              //console.log('response',response);
              this.form.shippingidchk = [];
              this.$alertify.success("Success!");

              this.searchTransitApprovalData();
              this.reset();
              this.selectedCount = 0
              //console.log('response', response);
            }).catch((httpException) => {
                  this.$alertify.success("No Records Found!");
                  console.error('exception is:::::::::', httpException)
            });
          }
        }
      }).catch(() => {
        console.log('errors exist', this.errors)
      });
    },
    validateForm2(scope) {
        this.$validator.validateAll(scope).then(result => {

        if (result) {
          if(this.selectedItems.length > 0){
            let shipmentpayload = [];
            this.isSaveLoading = true
            this.selectedItems.forEach((item)=>{
              for (let lostList in this.lostBagShipments) {
                var isExistuserid = item.includes(this.lostBagShipments[lostList].ShippingID.toString());
                if(isExistuserid){

                  shipmentpayload.push({
                    "ClientID": this.lostBagShipments[lostList].ClientID,
                    "ShippingID": this.lostBagShipments[lostList].ShippingID,
                    "OriginHubID": this.lostBagShipments[lostList].OriginHubID,
                    "FinalDestinationId": this.lostBagShipments[lostList].FinalDestinationId,
                    "CurrentHubId": this.lostBagShipments[lostList].CurrentHubId,
                    "Status": this.lostBagShipments[lostList].Status,
                    "ShipmentStatus": this.lostBagShipments[lostList].ShipmentStatus,
                    "NetPayment": this.lostBagShipments[lostList].NetPayment != null ? this.lostBagShipments[lostList].NetPayment : 0,
                    "OctroiMRP": this.lostBagShipments[lostList].OctroiMRP != null ? this.lostBagShipments[lostList].OctroiMRP : 0,
                    "ClientName": this.lostBagShipments[lostList].ClientName,
                    "CurrentHubName": this.lostBagShipments[lostList].CurrentHubName,
                    "OriginHubName": this.lostBagShipments[lostList].OriginHubName,
                    "FinalDestinationName": this.lostBagShipments[lostList].FinalDestinationName,
                    "HubZoneName": this.lostBagShipments[lostList].CurrentHubZoneName,
                    "HubZoneID": this.lostBagShipments[lostList].CurrentHubZoneID
                  })
                }
              }
            })

            let debitToPayload = {
              "shipmentsData" : shipmentpayload,
              "DebitFromType" : this.debitFrom,
              "DocketNumber" : this.DocketNumber,
              "Comments" : this.comments,
              "DebitFrom": this.debitTo.text,
              "CreatedBy" : this.localusermailid
            }
            if (this.debitFrom == "Coloader") {
              debitToPayload.ColoaderID = this.debitTo.id;
            }
            else if (this.debitFrom == "NetworkVendor") {
              debitToPayload.VehicleVendorID = this.debitTo.id;
            }

            axios.post(apiUrl.api_url + 'BulkTransitMarkLost/confirmLost', debitToPayload)
              .then((response) => {
                  //console.log('payload :',response);
                  if(response.data.code==200){
                    this.$alertify.success("Successfully marked Lost");
                  }else{
                    this.$alertify.error(response.data.message);
                  }
                  this.onSubmitReset()
                  this.searchTransitApprovalData();
                  this.isSaveLoading = false

              }).catch((httpException) => {
                    this.$alertify.success("Unable to mark lost!");
                    this.isSaveLoading = false
                    console.error('exception is:::::::::', httpException)
              });
              //console.log('payload :',debitToPayload);
          }


        }
      }).catch((httpException) => {
        this.$alertify.error("No Records Found!");
        this.isSaveLoading = false
        console.error('exception is:::::::::', httpException)
      });
    },
    //to get pagination
    getPaginationData(pageNum) {
      //console.log('pageNum',pageNum);
        this.pageno = pageNum;
        this.searchTransitApprovalData();
    },

    //search Raise Debit data
    searchTransitApprovalData(){
     //console.log("In Function",this.$validator);
      this.$validator.validateAll().then((result) => {
        if(result){
          let payload = {};
          payload.BagNumber = this.bagno;
          payload.pageNo = this.pageno;
          payload.pageSize = 10;
          this.isSearchLoading = true;
          axios.post(apiUrl.api_url + 'bagInNotifyNOInfoShipments/list', payload)
            .then((response) => {
              //console.log('response',response.data);
              this.selectedItems = [];
              this.netPayment = [];
              this.OctroiMRP = [];
              this.TotalNetAmt = 0;
              this.TotaloctroAmt = 0;
              this.TotalDebitAmount = 0;
              this.isShowing=false;

              if(response.data.code==200){
                 this.lostBagShipments = response.data.data;
                 this.totalRecord = this.lostBagShipments.length
                 let lostBagShipmentsObj = response.data.data;
                 let lostbaglength = response.data.data.length;
                 for(let i=0;i<lostbaglength;i++){
                   this.netPayment[parseFloat(lostBagShipmentsObj[i].ShippingID)] = lostBagShipmentsObj[i].NetPayment == null ? 0 : parseFloat(lostBagShipmentsObj[i].NetPayment);
                   this.OctroiMRP[parseFloat(lostBagShipmentsObj[i].ShippingID)] = lostBagShipmentsObj[i].OctroiMRP == null ? 0 : parseFloat(lostBagShipmentsObj[i].OctroiMRP);
                 }
                  this.isShowing=true;
              }else{
                this.$alertify.error("No Records Found!");
                this.lostBagShipments = [];
                this.netPayment = [];
                this.OctroiMRP = [];
                this.isShowing=false;
              }
              console.log('shipmentList',this.lostBagShipments);
              this.isSearchLoading = false;
            })
            .catch((httpException) => {
                this.$alertify.success("No Records Found!");
                this.isSearchLoading = false;
                console.error('exception is:::::::::', httpException)
            });
        }
      }).catch(() => {
        this.isSearchLoading = false;
        console.log('errors exist', this.errors)
      });
    },
    DebitFromData(){

      let debitFromTypeOveride;
      if(this.debitFrom == "NetworkVendor"){
        debitFromTypeOveride =  "Network Vendor";
      }else {
        debitFromTypeOveride = this.debitFrom;
      }
      if(this.selectedItems.length > 0){

        axios.post(apiUrl.api_url + 'external/getOptTypeDetails', {"ShippingId":this.lostBagShipments[0].ShippingID,"OptType":debitFromTypeOveride})
         .then((response) => {
             if(response.data.code === 200){
                 this.debitToObj =response.data.data;
                 console.log('this.debitToObj',this.debitToObj);
             }
             else {
                 this.debitToObj = [];
                 this.$alertify.error(response.data.message);
             }
         })
         .catch((httpException) => {
             this.$alertify.error("debit data not found");
             console.error('exception is:::::::::', httpException)
         })
      }else{
        this.$alertify.error("Please Select above shipment for details");
      }
    },
    selectItems(getevent) {
      if (getevent.target.checked == true) {
          for (let lostList in this.lostBagShipments) {
            var isExistuserid = this.selectedItems.includes(this.lostBagShipments[lostList].ShippingID.toString());
            if(!isExistuserid){
              this.selectedItems.push(this.lostBagShipments[lostList].ShippingID.toString());
            }
          }
          this.shipmentList = this.selectedItems.length;
          this.selectedCount = this.selectedItems.length
        }else{
          this.selectedItems = [];
          this.TotalDebitAmount = 0.00;
          this.TotalNetAmt = 0.00;
          this.TotaloctroAmt = 0.00;
          this.shipmentList = '';
        }
        this.calculateDebitAmout();
    },

    calculateDebitAmout(getShippingIds = ''){
      this.selectedCount = 0
      // console.log('getShippingIds ===>>', getShippingIds);
      if(this.selectedItems.length > 0){
        //this.isDebitPersonSelected = this.selectedItems.length;

        let selectDebitUsercount = this.selectedItems.length;
        let raiseDebitAmount = 0;
        let finaltotalNetAmt = 0;
        let finaltotaloctroAmt = 0;
        let setDebitAmountGreaterValue = 0;
        for(let i = 0; i<selectDebitUsercount ; i++){

          if(this.netPayment[this.selectedItems[i]] > this.OctroiMRP[this.selectedItems[i]]) {
            setDebitAmountGreaterValue = parseFloat(setDebitAmountGreaterValue) +  parseFloat(this.netPayment[this.selectedItems[i]])
          } else if (this.netPayment[this.selectedItems[i]] <= this.OctroiMRP[this.selectedItems[i]]) {
            setDebitAmountGreaterValue = parseFloat(setDebitAmountGreaterValue) +  parseFloat(this.OctroiMRP[this.selectedItems[i]])
          } else {
            setDebitAmountGreaterValue = parseFloat(setDebitAmountGreaterValue) +  parseFloat(tempSetOctaAmount)
          }

          finaltotalNetAmt = parseFloat(finaltotalNetAmt) + parseFloat(this.netPayment[this.selectedItems[i]])
          finaltotaloctroAmt = parseFloat(finaltotaloctroAmt) + parseFloat(this.OctroiMRP[this.selectedItems[i]])
          // console.log('setDebitAmountGreaterValue ====>>>>', setDebitAmountGreaterValue);
          // finaltotalNetAmt = parseFloat(finaltotalNetAmt) + (!isNaN(this.netPayment[this.selectedItems[i]])) ? parseFloat(this.netPayment[this.selectedItems[i]]) : 0;
          // finaltotaloctroAmt = parseFloat(finaltotaloctroAmt) + (!isNaN(this.OctroiMRP[this.selectedItems[i]])) ? parseFloat(this.OctroiMRP[this.selectedItems[i]]) : 0;
        }
        // this.TotalDebitAmount = parseFloat(finaltotalNetAmt) + parseFloat(finaltotaloctroAmt);
        this.TotalDebitAmount = parseFloat(setDebitAmountGreaterValue);
        this.TotalNetAmt = parseFloat(finaltotalNetAmt);
        this.TotaloctroAmt = parseFloat(finaltotaloctroAmt);
        this.shipmentList = this.selectedItems.length;
        this.selectedCount = this.selectedItems.length
        //console.log('this.TotalDebitAmount',this.TotalDebitAmount);
      }else{
        //console.log('false');
        this.TotalDebitAmount = 0.00;
        this.TotalNetAmt = 0.00;
        this.TotaloctroAmt = 0.00;
        this.shipmentList = '';
      }
    },
    onSubmit: function(event) {
      this.$validator.validateAll().then((result) => {
        if(result){
          this.searchRaiseDebitData(event);
        }
      }).catch(() => {
        console.log('errors exist', this.errors)
      });
    },
    exportForm(){
      if(this.shipmentListCSV==undefined || this.shipmentListCSV.length==0){
        this.$alertify.alert("No data","No data available for download.");
      }
      this.getDownloadCsvObject(this.shipmentListCSV);
    },
    changeDateFormat(inputString){
      let current_datetime = new Date(inputString)
      let formatted_date = current_datetime.getDate() + "-" + (current_datetime.getMonth() + 1) + "-" + current_datetime.getFullYear();
      return formatted_date;
    },
    getDownloadCsvObject(result) {
      var csvData = result;
      var today = new Date();
      var dd = today.getDate();
      var mm = today.getMonth() + 1;
      var yyyy = today.getFullYear();
      var today = dd + "" + mm + "" + yyyy;
      var data, filename, link;
      filename = "MarkLostShipment_" + today + ".csv";
      var csv = this.convertArrayOfObjectsToCSV({
        data: csvData
      });
      if (csv == null) return;
      filename = filename || "export.csv";
      if (!csv.match(/^data:text\/csv/i)) {
        csv = "data:text/csv;charset=utf-8," + csv;
      }
      data = encodeURI(csv);
      link = document.createElement("a");
      link.setAttribute("href", data);
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
      link.removeChild(link);
    },
    convertArrayOfObjectsToCSV: function(args) {
      var result, ctr, keys, columnDelimiter, lineDelimiter, data;
      data = args.data || null;
      if (data == null || !data.length) {
        return null;
      }
      columnDelimiter = args.columnDelimiter || ",";
      lineDelimiter = args.lineDelimiter || "\n";
      keys = Object.keys(data[0]).slice(0);
      result = "";
      result += keys.join(columnDelimiter);
      result += lineDelimiter;
      data.forEach(function(item) {
        ctr = 0;
        keys.forEach(function(key) {
          if (ctr > 0) result += columnDelimiter;
          if (item[key] != null) {
            result += '"' + item[key] + '"';
          }
          ctr++;
        });
        result += lineDelimiter;
      });
      return result;
   },
   onSubmitReset(){
     this.pageno = 1;
     this.TotalDebitAmount = 0.00;
     this.TotalNetAmt = 0.00;
     this.TotaloctroAmt = 0.00;
     this.debitFrom = '';
     this.debitTo = '';
     this.DocketNumber = '';
     this.comments = '';
     this.selectedItems = [];
     this.lostBagShipments = [];
     this.selectedCount = 0
     this.lostDebitCheckAll = false
     this.$validator.reset();
     this.errors.clear();
   },
   reset(){
     this.bagno = '';
     this.pageno = 1;
     this.TotalDebitAmount = 0.00;
     this.TotalNetAmt = 0.00;
     this.TotaloctroAmt = 0.00;
     this.debitFrom = '';
     this.debitTo = '';
     this.DocketNumber = '';
     this.comments = '';
     this.selectedItems = [];
     this.lostBagShipments = [];
     this.isShowing=false;
     this.selectedCount=0
     this.$validator.reset();
     this.errors.clear();
   },
    resetForm() {
        this.bagno = '';
        this.pageno = 1;
        this.isShowing=false;
        this.selectedCount=0
        this.lostDebitCheckAll = false
    },

  },
  filters: {
    setValidNumber: function(value) {
      if (value == null || value == '')
        return '0'
      return value;
    },
  }
}



// WEBPACK FOOTER //
// ./src/views/components/LOST/BulkTransitLostMark/BulkTransitLostMark.component.js